// Saved raster images are self-contained; saved blob URLs depend on a lost browser session.
export function isMissingPostMedia(media, imageChanges = []) {
  if (!media) return true
  if (media.publicID) return false
  if (typeof media.url !== 'string' || !media.url.trim()) return true

  if (/^(?:data|blob):/i.test(media.url) && imageChanges.some(change => change.element && change.url === media.url)) {
    return false
  }
  if (/^data:/i.test(media.url)) {
    return !/^data:image\/(?:png|jpeg|gif|webp|bmp|avif);base64,[A-Za-z0-9+/]+={0,2}$/i.test(media.url)
  }
  if (/^blob:/i.test(media.url)) {
    return true
  }
  return false
}



// WEBPACK FOOTER //
// ./src/components/views/Post/postMedia.js